import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').factory('MetricsDA', MetricsDA);

    MetricsDA.$inject = ['CONF', 'Restangular'];

    /* @ngInject */
    function MetricsDA(CONF, Restangular) {
        var baseUrl = CONF.apiBaseUrl + '/v1/health';

        var exports = {
            getAppHealth: getAppHealth,
            getPreinvoicesHealth: getPreinvoicesHealth,
            getScheduledTasksHealth: getScheduledTasksHealth
        };

        return exports;

        //----------------
        //----------------

        function getAppHealth() {
            return Restangular.one(baseUrl).get();
        }

        function getPreinvoicesHealth() {
            return Restangular.one(baseUrl, 'preinvoices').get();
        }

        function getScheduledTasksHealth() {
            return Restangular.one(baseUrl, 'scheduled-tasks').get();
        }
    }
})();
